module.exports = __webpack_public_path__ + "media/couriers/lp_logo-28663e30.png";